import { Controller } from 'stimulus';

class OrderData extends Controller {
  connect() {
    this.loadParcelPickupController()
      .then((controller) => {
        this.parcelPickupController = controller;
        this.parcelPickupElement = this.parcelPickupController.element;

        this.checkParcelPickupState();
      });

    this.otherAddressCheckWrapper = document.querySelector('.js-shipping-address-check-wrapper');
    this.otherAddressCheck = document.querySelector('.js-shipping-address-check');
    this.otherAddressForm = document.querySelector('.js-shipping-address');
    this.parcelPickupMessage = document.querySelector('.js-parcel-pickup-message');
    this.streetCityFields = document.querySelector('.js-parcel-pickup-street-city-fields');
    this.streetCityFieldsPreview = document.querySelector('.js-parcel-pickup-street-city-fields-preview');
    this.selectAddress = document.querySelector('.js-select-address');
    this.shippingCompanyName = document.querySelector('.js-shipping-company-name');
  }

  checkParcelPickupState() {
    if (this.parcelPickupShippingMethodTarget.checked) {
      // Open the ParcelPickup picker
      this.parcelPickupController.toggleParcelPickup(true);

      // Fetch locations based on the postal and house number field
      this.parcelPickupController.fetchPickupPoints()
        .then(this.parcelPickupSelectCompanyFromDataAttribute.bind(this));
    }
  }

  parcelPickupSelectCompanyFromDataAttribute() {
    const oldSelectedCompanyName = this.parcelPickupController.data.get('company-name');

    const oldSelectedCompany = this.parcelPickupElement
      .querySelector(`[data-company-name="${oldSelectedCompanyName}"]`);

    if (oldSelectedCompany) {
      oldSelectedCompany.className += ' is-active';

      $(oldSelectedCompany).trigger('click');
    }
  }

  parcelPickupOutputLocation(locationInformation) {
    this.otherAddressCheck.checked = true;
    this.otherAddressCheckWrapper.style.display = 'none';
    this.otherAddressForm.style.display = 'block';
    this.parcelPickupMessage.style.display = 'block';
    this.streetCityFields.style.display = 'block';
    this.streetCityFieldsPreview.style.display = 'none';
    this.shippingCompanyName.style.display = 'block';

    if (this.selectAddress) {
      this.selectAddress.style.display = 'none';
    }

    // Disable country dropdown
    this.otherAddressForm.querySelector('.custom-select').classList.add('is-disabled');

    this.outputValue('input[name="shipping_company_name"]', locationInformation.locationName);
    this.outputValue('select[name="shipping_country_id"]', 1);
    this.outputValue('input[name="shipping_postal_code"]', locationInformation.postal_code);
    this.outputValue('input[name="shipping_street"]', locationInformation.street);
    this.outputValue('input[name="shipping_house_number"]', locationInformation.number);
    this.outputValue('input[name="shipping_city"]', locationInformation.city);
    this.outputValue('input[name="parcel_location_id"]', locationInformation.location_code);
  }

  outputValue(fieldSelector, value) {
    this.otherAddressForm.querySelector(fieldSelector).setAttribute('readonly', true);
    this.otherAddressForm.querySelector(fieldSelector).value = value;
  }

  loadParcelPickupController() {
    return new Promise((resolve) => {
      const parcelPickupElement = this.element.querySelector('[data-controller="parcel-pickup"]');
      const controller = this.application.getControllerForElementAndIdentifier(parcelPickupElement, 'parcel-pickup');

      if (controller) {
        resolve(controller);
        return;
      }

      setTimeout(() => {
        this.loadParcelPickupController().then(resolve);
      }, 1000);
    });
  }
}

OrderData.targets = [
  'parcelPickupShippingMethod',
];

export default OrderData;
